import { render, staticRenderFns } from "./listar-clientes.vue?vue&type=template&id=4ec85ef4&scoped=true&"
import script from "./listar-clientes.vue?vue&type=script&lang=js&"
export * from "./listar-clientes.vue?vue&type=script&lang=js&"
import style0 from "./listar-clientes.vue?vue&type=style&index=0&id=4ec85ef4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec85ef4",
  null
  
)

export default component.exports